import { Component, Input } from "@angular/core";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ra-content-desktop-button-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="bg-white rounded-lg shadow relative">
      <div class="flex flex-col items-start px-4 py-2">
          <span class="text-base text-[#1C212D] text-left whitespace-nowrap">
          {{ tooltipText }}
        </span>
      </div>
      <div class="w-8 overflow-hidden inline-block -translate-x-[15px] bottom-10 left-1/2 absolute">
        <div class="h-5 w-5 bg-white shadow rotate-45 transform origin-bottom-left"></div>
      </div>

    </div>

  `,
  styles: `
    :host {
        @apply absolute;
    }
  `
})
export class ContentDesktopButtonTooltipComponent {
  @Input() tooltipText!: string;
}
